import { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { withTranslation, WithTranslation } from 'react-i18next';

import { StoreI } from '~src/rootReducer';
import { getAttribute } from '~src/modules/attributes/reducers/attributes.reducer';
import { translateContent } from '~src/services/translationServices';
import TextBtnPageFooter from '~src/shared/footers/textBtnPageFooter/TextBtnPageFooter';
import PageLoader from '~src/shared/pageLoader/PageLoader';
import logger from '~src/services/logger/LlsLogger';
import { AttributeI, AttrInternalType } from '~src/interfaces/attributes.types';
import { fetchAttributesList } from '~src/modules/attributes/actions/attributes.actions';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import { routes } from '~src/routingConfig';

import AttributeOptionList from './options/AttributeOptionList';
import AttributeOptionAdd from './options/AttributeOptionAdd';
import { OptionAddContainer, PageContentContainerS, AttrOptionsContainer } from './attributesDetails.sc';
import AttributeHeader from './AttributeHeader';

interface StateProps {
  attribute?: AttributeI;
}

interface DispatchProps {
  fetchAttributesList(): ApiReduxResp<void>;
}

type Props = DispatchProps & StateProps & WithTranslation & RouteComponentProps<{ attributeId: string }>;

const AttributeDetails: FC<Props> = (props) => {
  const [loading, setLoading] = useState(true);
  const attrId = props.match.params.attributeId;
  useEffect(() => {
    if (!props.attribute) {
      props
        .fetchAttributesList()
        .then((res) => {
          if (res.error) {
            throw new Error('Error fetching attributes list');
          }
          setLoading(false);
        })
        .catch((error) => {
          logger.info('Error fetching attributes list', {
            error,
            info: {
              componentStack: 'AttributesDetail.jsx',
            },
          });
        });
    } else {
      setLoading(false);
    }
  }, [props.attribute]);

  const footerTxtKey = props.attribute
    ? `x.attributes.details.footer.info_text.${props.attribute.internal_type}`
    : '';

  const { t, history, attribute } = props;

  return loading || !attribute ? (
    <PageLoader />
  ) : (
    <PageContentContainerS>
      <AttributeHeader attribute={attribute} />
      {attribute.internal_type === AttrInternalType.Option && (
        <OptionAddContainer>
          <AttributeOptionAdd t={t} attribute={attribute} />
          <AttrOptionsContainer>
            <AttributeOptionList
              t={t}
              valueList={attribute.attribute_options}
              attributeName={translateContent(attribute.name)}
              attributeId={attrId}
            />
          </AttrOptionsContainer>
        </OptionAddContainer>
      )}
      <TextBtnPageFooter
        t={t}
        infoKey={footerTxtKey}
        infoTxt={t(footerTxtKey, { attributeName: translateContent(attribute.name) })}
        btnKey="x.attributes.details.footer.button.to_user_management"
        linkUrl={routes.company.users}
      />
    </PageContentContainerS>
  );
};

const mapStateToProps = (state: StoreI, { match }: Props): StateProps => ({
  attribute: getAttribute(state, match.params.attributeId),
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  fetchAttributesList: () => dispatch(fetchAttributesList()),
});

const AttributeDetailsT = withTranslation()(AttributeDetails);
const AttributeDetailsC = connect(mapStateToProps, mapDispatchToProps)(AttributeDetailsT);
export default AttributeDetailsC;
